import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    title: 'Gestión del tiempo ineficaz',
    desc: 'Intentaste gestionar tu tiempo con agendas, pero el problema es que tu energía estaba por los suelos.'
  }, {
    title: 'Estrategias sin mentalidad',
    desc: "Buscaste la 'estrategia de inversión perfecta', pero tu mentalidad de escasez te hizo salir en el peor momento."
  }, {
    title: 'La trampa del hustle',
    desc: "Seguiste la cultura del 'hustle' extremo, ignorando que el cerebro humano bajo estrés no puede crear riqueza sostenible."
  }, {
    title: 'Manifestación vacía',
    desc: 'Trataste de manifestar abundancia sin antes limpiar el trauma emocional que te hace gastar lo que no tienes.'
  }];
  return <section className="bg-brand-cream text-brand-dark py-24 px-6" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center text-brand-dark" data-id="element-29">
            Por qué lo que has intentado{' '}
            <span className="text-red-800/80 italic" data-id="element-30">no ha funcionado</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-31">
          {approaches.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
              <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 h-full flex items-start gap-4" data-id="element-33">
                <XCircle className="w-6 h-6 text-red-800/60 flex-shrink-0 mt-1" data-id="element-34" />
                <div data-id="element-35">
                  <h3 className="font-bold text-xl mb-2 text-brand-green" data-id="element-36">
                    {item.title}
                  </h3>
                  <p className="text-brand-dark/70 leading-relaxed font-light" data-id="element-37">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}